import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown";
import { ViewPriceDetails } from "./banners/ViewPriceDetails";
import {
  useUnifiedPriceBreakdownPostBookingController,
  type UnifiedPriceBreakdownPostBookingControllerProps
} from "./useUnifiedPriceBreakdown.PostBooking.controller";
import { UnifiedPriceBreakdownPostBooking } from "./UnifiedPriceBreakdown.PostBooking";

export type UnifiedPriceBreakdownPostBookingSummaryProps = UnifiedPriceBreakdownPostBookingControllerProps;

export function UnifiedPriceBreakdownPostBookingSummary(props: UnifiedPriceBreakdownPostBookingSummaryProps) {
  const { unifiedPriceBreakdown, isHungaryDepartingRyanAir, addedItems, expandedByDefault } =
    useUnifiedPriceBreakdownPostBookingController(props);

  if (!unifiedPriceBreakdown) {
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        isSummary={true}
        addedItems={addedItems}
        expandedByDefault={expandedByDefault}
      />
      <ViewPriceDetails>
        <UnifiedPriceBreakdownPostBooking {...props} />
      </ViewPriceDetails>
    </Stack>
  );
}
